import { render, staticRenderFns } from "./FutureHouseFrame.vue?vue&type=template&id=05c29bd5"
import script from "./FutureHouseFrame.vue?vue&type=script&lang=js"
export * from "./FutureHouseFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c29bd5')) {
      api.createRecord('05c29bd5', component.options)
    } else {
      api.reload('05c29bd5', component.options)
    }
    module.hot.accept("./FutureHouseFrame.vue?vue&type=template&id=05c29bd5", function () {
      api.rerender('05c29bd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/future_house_awards/components/FutureHouseFrame.vue"
export default component.exports